import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import _, { forEach, set } from 'lodash';
import groupService from '../../Group/services';
import xlsx from 'json-as-xlsx';
import tokenService from '../../../Common/tokenDecoder';
import services from '../services';

export const FieldListing = ({ fieldFilteringData, handleClick }) => {
    const [fieldFiltering, setFieldFiltering] = useState([]);
    const [groups, setGroups] = useState([]);
    const [operationEntities, setOperationEntities] = useState([]);
    const contentRowNames = ["fieldCode", "fieldName", "isActive"];
    const csvHeaders = [
        { label: "Field Code", value: "fieldCode" },
        { label: "Field Name", value: "fieldName" },
    ];

    
    useEffect(() => {
        trackPromise(
            getGroupsForDropdown()
        )
    }, [fieldFilteringData]);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [fieldFiltering[0]]);

    useEffect(() => {
        trackPromise(
            setFieldFilteringData()
        )
    }, [fieldFilteringData]);

    async function setFieldFilteringData() {
        destroyDataTable();
        await setFieldFiltering(fieldFilteringData);
        createDataTable();
    }
    

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getEstates() {
        const result = await services.getEstatesByGroupID(fieldFiltering[0].groupID)
        setOperationEntities(result)
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ?
                (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                : <td key={index}>{da[row] + " "}</td>
            )
        )
    });
    function createFile() {
        var settings = {
            sheetName: 'Field',
            fileName: 'Field',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(fieldFiltering)

        var newRow1 = {
          fieldCode: "Group :" + groups[fieldFiltering[0].groupID],
          fieldName: "Estate :" + operationEntities[fieldFiltering[0].operationEntityID]
        };
        var newRow2 = {
            fieldCode: "Generated date/time : " + new Date().toLocaleString(),
            fieldName:"Generated user : " + tokenService.getUserNameFromToken(),
        };
        copyOfCsv.push({}, {},newRow1);
        copyOfCsv.push({}, {},newRow2)
     
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <hr />
                        {fieldFiltering.length > 0 ?
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Field Code</th>
                                        <th>Field Name</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fieldFiltering.map((data, i) => {
                                        return (
                                            <tr key={i}>
                                                {content(data)}
                                                <td onClick={() => handleClick(data)} style={{ cursor: "pointer" }}><i class="far fa-edit"></i></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                    </div>
                        </div>: null }
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


